<button
  pButton
  [rounded]="true"
  icon="fas fa-file-lines"
  [label]="story.title"
  (click)="openStory()"></button>
